/* eslint-disable no-unused-expressions */
import React from "react";

import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const GalleryPage = () => {
  const { galleryApi } = apiPath;
  const [gallery, galleryLoading] = useFetch(galleryApi);
  if (galleryLoading) {
    return <Loading />;
  }
  const { title, slogan, images } = gallery;

  const imagesData = [];
  images.map((item, index) => {
    imagesData.push({
      label: `Gallery Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item,
      required: false,
    });
  });

  const data = [
    {
      elementType: "input",
      label: "Title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: true,
    },
    {
      elementType: "textField",
      label: "Slogan",
      type: "Text",
      name: "slogan",
      defaultValue: slogan,
      required: false,
    },
  ];

  const nestedData = [
    {
      elementType: "file",
      label: "Gallery Image",
      name: "images",
      multipleData: imagesData,
      multiple: true,
      fullCol: true,
      required: false,
    },
  ];

  const useData = data.concat(nestedData);
  const update = (data) => {
    updateData(galleryApi, data);
  };
  return (
    <div>
      <GlobalForm data={useData} nestedData={nestedData} update={update} />
    </div>
  );
};

export default GalleryPage;
